/**
 * Free shipping progress bar: international currencies.
 *
 * The free shipping goal is set in the shop currency (AUD). When a customer
 * shops in another currency, Liquid compares that AUD amount against a cart
 * total in their currency, so the bar would be wrong. This converts the goal
 * with Shopify's live rate and rounds it UP to the next .99 (e.g. £49.12 ->
 * £49.99). Rounding up, never down, keeps the bar from promising free shipping
 * before checkout (which uses the exact converted amount) will give it.
 *
 * Only the free-shipping-only setup is handled (no free product goal).
 */
(function () {
  const BAR = ".free-product-progress-bar-main";

  function convertedThreshold(baseCents, rate) {
    const amount = (baseCents / 100) * rate;
    if (/amount_no_decimals/.test(window.Shopify?.money_format || "")) {
      // Zero-decimal currencies (JPY etc.): round up to the next ...99
      return (Math.ceil((amount + 1) / 100) * 100 - 1) * 100;
    }
    return Math.round((Math.ceil(amount + 0.01) - 0.01) * 100);
  }

  function formatMoney(cents) {
    const formatted = Shopify.formatMoney(cents);
    return cents % 100 === 0 ? formatted.replace(/[.,]00(?=\D*$)/, "") : formatted;
  }

  function cartTotal(bar) {
    const scope = bar.closest("cart-drawer") || document;
    return parseInt(scope.querySelector(".gb-totals-total-value")?.textContent || "0", 10);
  }

  function localize(bar) {
    if (bar.dataset.fsLocalized) return;
    bar.dataset.fsLocalized = "true";

    const baseCents = parseInt(bar.dataset.fsThreshold || "0", 10);
    const active = window.Shopify?.currency?.active;
    const rate = parseFloat(window.Shopify?.currency?.rate || "1");
    const message = bar.querySelector(".free-product-progress-bar-successfull");
    const progressWrap = bar.querySelector(".free-product-progress-bar");
    const progress = progressWrap?.querySelector("progress");

    if (!baseCents || !message || !progress) return;
    if (!active || active === bar.dataset.fsShopCurrency || !rate || rate === 1) return;
    if (parseInt(progressWrap.dataset.freeProductPrice || "0", 10) > 0) return;

    const threshold = convertedThreshold(baseCents, rate);
    const total = cartTotal(bar);

    progressWrap.dataset.freeShippingPrice = threshold;
    progress.max = threshold;
    bar.querySelector(".free-shipping-main")?.classList.toggle("free-shipping-main-color", total >= threshold);

    if (total >= threshold) {
      message.textContent = message.dataset.fsEarn || "";
    } else {
      const [before, after = ""] = (message.dataset.fsAway || "").split("[missingAmount]");
      const amount = document.createElement("span");
      amount.className = "fs-missing-amount";
      amount.textContent = formatMoney(threshold - total);
      message.replaceChildren(before, amount, after);
    }
  }

  function localizeAll() {
    document.querySelectorAll(BAR).forEach(localize);
  }

  // The cart drawer is re-rendered from the server after every cart change.
  // MutationObserver callbacks run before the next paint, so the AUD figure
  // never flashes on screen.
  function init() {
    localizeAll();
    const drawer = document.querySelector("cart-drawer");
    if (drawer) new MutationObserver(localizeAll).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
